import { Dialog } from "@gravity-ui/uikit";
import { ProductDetailResponseDto } from "definitions/product-storage";

import { ProductContentWithPayment } from "../ProductModalContent";
import css from "./ProductModal.module.scss";

interface ProductModalProps {
  open: boolean;
  onClose: () => void;

  product: ProductDetailResponseDto | null;
  isLoading?: boolean;
  hasMoney?: boolean;
  hasSubscribe?: boolean;
}

export const ProductModal = ({
  open,
  onClose,
  product,
  isLoading,
  hasMoney,
  hasSubscribe,
}: ProductModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} size="l">
      <div className={css.wrapper}>
        <ProductContentWithPayment
          product={product}
          isLoading={isLoading}
          hasMoney={hasMoney}
          hasSubscribe={hasSubscribe}
        />
      </div>
    </Dialog>
  );
};
